import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL, WHATSAPP_LINK } from "@/pages/home/constants";

const NAV_LINKS = [
  { href: "#passeio-de-lancha", label: "Passeios" },
  { href: "#roteiros", label: "Roteiro" },
  { href: "#nossas-lanchas", label: "Frota" },
  { href: "#jet-ski", label: "Jet Ski" },
  { href: "#splash-deck", label: "Splash Deck" },
  { href: "#embarque", label: "Embarque" },
  { href: "#contato", label: "Contato" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div
        className={`w-full transition-all duration-300 ${
          scrolled
            ? "bg-primary-950/95 backdrop-blur border-b border-white/10"
            : "bg-gradient-to-b from-primary-950/85 to-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 md:h-16">
            <Link to="/" className="flex items-center cursor-pointer flex-shrink-0">
              <img
                src={LOGO_URL}
                alt="Eco Tour Turismo — Passeios de Lancha em Capitólio"
                title="Eco Tour Turismo Capitólio"
                className="h-10 md:h-12 w-auto object-contain"
              />
            </Link>

            <nav className="hidden md:flex items-center gap-6 lg:gap-7">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-[13px] font-medium text-white/80 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>

            <div className="flex items-center gap-3">
              <a
                href={WHATSAPP_LINK}
                data-whatsapp-cta
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-[13px] font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base" />
                Falar no WhatsApp
              </a>
              <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="md:hidden w-9 h-9 rounded-md bg-white/10 flex items-center justify-center text-white cursor-pointer"
                aria-label="Menu"
                aria-expanded={open}
              >
                <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-primary-950/95 backdrop-blur border-b border-white/10 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 py-3 flex flex-col gap-0.5">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="text-white/80 hover:text-white text-sm font-medium py-2 px-3 rounded-md hover:bg-white/10 transition-all cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_LINK}
            data-whatsapp-cta
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap mt-1.5"
          >
            <i className="ri-whatsapp-line text-lg" />
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}